/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Attach_Entity_HintInputs */

const cs_chat_attach_entity_hint = /** @type {(inputs: Chat_Attach_Entity_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sdílejte záznam z CRM. Otevře se podle práv příjemce.`)
};

const en_chat_attach_entity_hint = /** @type {(inputs: Chat_Attach_Entity_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Share a CRM record. Recipients open it with their own access.`)
};

/**
* | output |
* | --- |
* | "Share a CRM record. Recipients open it with their own access." |
*
* @param {Chat_Attach_Entity_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const chat_attach_entity_hint = /** @type {((inputs?: Chat_Attach_Entity_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Attach_Entity_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_chat_attach_entity_hint(inputs)
	return cs_chat_attach_entity_hint(inputs)
});